import React from 'react'
import { PoseGroup } from 'react-pose'
import { useToggle } from '../../hooks'
import Container from '../Container'
import { StyledDrawer, StyledDrawerWrraper, StyledDrawerOverlay, StyledDrawerContent, StyledDrawerItems, StyledDrawerItemWrapper, StyledDrawerItem, StyledDrawerItemText, StyledDrawerItemIcon, StyledIcon } from './styled'

const Drawer = ({ drawerItems }) => {
    const [isOpen, toggleIsOpen] = useToggle(false)
    return (
        <StyledDrawer>
            <StyledIcon name='expand' active={isOpen} onClick={toggleIsOpen} />
            <PoseGroup>
                {
                    isOpen &&
                    <StyledDrawerWrraper key='drawer'>
                        <StyledDrawerOverlay onClick={toggleIsOpen} />
                        <StyledDrawerContent>
                            <Container>
                                <StyledDrawerItems>
                                    {
                                        drawerItems &&
                                        drawerItems.map(({ text, disabled = false, customContent, callback, icon, show = true }, index) => (
                                            <React.Fragment
                                                key={text || index}
                                            >
                                                {
                                                    show &&
                                                    <StyledDrawerItem
                                                        disabled={disabled}
                                                    >
                                                        {
                                                            customContent ?
                                                                (
                                                                    customContent({ handleToggleIsOpenDrawer: toggleIsOpen })
                                                                )
                                                                :
                                                                (
                                                                    <StyledDrawerItemWrapper
                                                                        onClick={callback && callback(toggleIsOpen)}
                                                                    >
                                                                        <StyledDrawerItemIcon
                                                                            disabled={disabled}
                                                                            name={icon}
                                                                        />
                                                                        <StyledDrawerItemText>
                                                                            {text}
                                                                        </StyledDrawerItemText>
                                                                    </StyledDrawerItemWrapper>
                                                                )
                                                        }
                                                    </StyledDrawerItem>
                                                }
                                            </React.Fragment>
                                        ))
                                    }
                                </StyledDrawerItems>
                            </Container>
                        </StyledDrawerContent>
                    </StyledDrawerWrraper>
                }
            </PoseGroup>
        </StyledDrawer>
    )
}

export default Drawer
